'use client'

import { SessionProvider } from 'next-auth/react'
import { ToastProvider } from '@/components/ui/toast'
import { CommandPalette } from '@/components/CommandPalette'
import { AIProvider } from '@/context/AIContext'
import { AIManager } from '@/components/ai/AIManager'
import { RoleSyncGuard } from '@/components/auth/RoleSyncGuard'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider
      basePath={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/api/auth`}
      // Refetch session every 3 minutes so JWT refresh runs before typical short access-token expiry
      refetchInterval={3 * 60}
      // Refetch when window regains focus to handle long idle periods
      refetchOnWindowFocus={true}
      // Keep trying to refetch if there are errors, but not when offline
      refetchWhenOffline={false}
    >
      <RoleSyncGuard />
      <AIProvider>
      {children}
      <ToastProvider />
      <CommandPalette />
        <AIManager />
      </AIProvider>
    </SessionProvider>
  )
}
